import {
  GET_PROFILECONFIG_ACTIVE_REQUEST,
  GET_PROFILECONFIG_ACTIVE_SUCCESS,
  GET_PROFILECONFIG_ACTIVE_FAIL
} from '../../constants/profileconfig'

const initialState = {
  loading: false,
  profileConfig: null,
  error: null
}

const profileconfigReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PROFILECONFIG_ACTIVE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      }
    case GET_PROFILECONFIG_ACTIVE_SUCCESS:
      return {
        ...state,
        loading: false,
        profileConfig: action.payload
      }
    case GET_PROFILECONFIG_ACTIVE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        profileConfig: null
      }
    default:
      return state
  }
}

export default profileconfigReducer
